<template>
    <div class="row">
        <div class="col-xs-10 col-xs-offset-1">
            <eligibility-form
                :form-config="formConfig"
                @filter-list="handleFilterList"
            ></eligibility-form>
        </div>
        <div class="col-xs-10 col-xs-offset-1">
            <eligibility-list
                :bill-account-list="billAccountList"
            ></eligibility-list>
        </div>
    </div>
</template>

<script>

export default {

    props: {
        formConfig: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            billAccountList: null,
        }
    },

    methods: {
        handleFilterList(data) {
            if(! data.length > 0) {
                window.notify.message('No results found.', 'error');
            }
            this.billAccountList = data;
        }
    }
}
</script>
